import { createEvent, createStore } from 'effector';

import { ConfirmationProps } from './types';

export type Confirmation = ConfirmationProps & {
    confirmText?: string;
};

export const showConfirmation = createEvent<Confirmation>();
export const hideConfirmation = createEvent<number>();
export const removeAllConfirmations = createEvent();

export const confirmationStore = createStore<Confirmation[]>([])
    .on(showConfirmation, (state, confirmation) => {
        const array = new Uint32Array(1),
            [id] = window.crypto.getRandomValues(array);
        return [...state, { ...confirmation, id }];
    })
    .on(hideConfirmation, (state, id) => state.filter((conf) => conf.id !== id))
    .reset(removeAllConfirmations);
